import { Box } from '@mui/material'
import { createContext, PropsWithChildren, useContext, useState } from 'react'

import { PageLoader } from '#/contexts/Loader/loader'
import { ContextLoaderData, ContextLoaderOptions } from '#/contexts/Loader/types'

const ContextLoader = createContext({} as ContextLoaderData)

const defaultProps: ContextLoaderOptions = {
  error: false,
  loading: true,
  subtitle: null,
  title: null,
}

export function LoaderProvider({ children }: PropsWithChildren) {
  const [options, setOptions] = useState<ContextLoaderOptions>(defaultProps)
  const { ellipsis = true, error, loading, subtitle, title } = options

  return (
    <ContextLoader.Provider value={{ setOptions }}>
      <PageLoader
        loading={loading}
        title={title}
        subtitle={subtitle}
        ellipsis={ellipsis}
        error={error}
      />
      <Box sx={loading ? { display: 'none' } : undefined}>{children}</Box>
    </ContextLoader.Provider>
  )
}

export const useLoaderContext = () => useContext(ContextLoader)
